import React from "react";
import { Container } from "@mui/material";
import GarpacReportsContainer from "./GarpacReportsContainer";

const JobMonitoringReports = () => {
  return (
    <Container maxWidth={false} disableGutters sx={{ width: "100%", maxWidth: "none", p: 0 }}>
      <GarpacReportsContainer defaultTab="monitored" />
    </Container>
  );
};

export default JobMonitoringReports;
